import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
export var GridItemContainerDefault = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick;
    return (React.createElement("div", { className: "flex flex--guts grid-item-container " + IdStyles.BuildMenuGridItemWrapper + " " + (className || ""), onClick: onClick },
        React.createElement("div", { className: IdStyles.BuildMenuGridItem + " " + (className || "") }, children)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/GridItemContainerDefault.tsx
// module id = 310
// module chunks = 3